import { Flex, NavigateButton, Tabs } from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { z } from 'zod';
import { OrganizationsPage } from './organization';
import { RolesPage } from './role';
import { UsersPage } from './user';

const tabKey = z.enum(['users', 'organizations', 'roles']);
type TabKey = z.infer<typeof tabKey>;

export const TenantManagerRootPage: FC = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const activeKey = searchParams.get('activeKey') ?? ('users' satisfies TabKey);

  return (
    <Tabs
      activeKey={activeKey}
      items={[
        {
          key: 'users' satisfies TabKey,
          label: t('users-page'),
          children: <UsersPage />,
        },
        {
          key: 'organizations' satisfies TabKey,
          label: t('organizations-page'),
          children: <OrganizationsPage />,
        },
        {
          key: 'roles' satisfies TabKey,
          label: t('roles-page'),
          children: <RolesPage />,
        },
      ]}
      onChange={(activeKey) => {
        setSearchParams({ activeKey }, { replace: true });
      }}
      tabBarExtraContent={
        <TenantManagerResourceGuard>
          <Flex gap={6}>
            {/* {activeKey === 'organizations' && (
              <DownloadOrganizationListCsvButton />
            )} */}
            <TenantManagerResourceGuard onlyEdit>
              <NavigateButton path={`${activeKey}/new`} text={t('create')} />
            </TenantManagerResourceGuard>
            {/* {activeKey === 'users' && <UsersActionsArea />} */}
          </Flex>
        </TenantManagerResourceGuard>
      }
    />
  );
};
